// extracted by mini-css-extract-plugin
export default {"card":"IndustryCard_card__KTgxI"};